import axios from "infra/http";
import { useQuery } from "react-query";
import { EmailHistoricoLog } from "./../typings/index";

function useHistoricoEmail(id: string | undefined) {
  return useQuery(
    `/v1/relatorios/email/${id}/history`,
    async () => {
      const { data } = await axios.get<EmailHistoricoLog[]>(
        `/v1/relatorios/emails/${id}/history`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoEmail;
